import { calculateChecksum } from './checksum';
import { encodeBase64Url } from './base64url';

function hexToBytes(hex: string, length: number): Uint8Array {
  const bytes = new Uint8Array(length);
  const cleanHex = hex.replace(/[^0-9a-fA-F]/g, '').padStart(length * 2, '0');
  for (let i = 0; i < length; i++) {
    bytes[i] = parseInt(cleanHex.substring(i * 2, i * 2 + 2), 16);
  }
  return bytes;
}

export function serializePayload(
  version: number,
  shareId: string,
  infoHash: string,
  manifestHash: string,
  flags: number
): string {
  // Contiguous memory-aligned 64-byte packet
  const packet = new Uint8Array(64);
  const view = new DataView(packet.buffer);
  
  // Byte 0: Version
  view.setUint8(0, version);
  // Byte 1: Flags
  view.setUint8(1, flags);
  // Bytes 2-3: Reserved (initialized to 0)
  view.setUint8(2, 0);
  view.setUint8(3, 0);
  
  // Bytes 4-19: Share ID (16 bytes)
  const shareBytes = hexToBytes(shareId, 16);
  packet.set(shareBytes, 4);
  
  // Bytes 20-39: Info Hash (20 bytes)
  const infoHashBytes = hexToBytes(infoHash, 20);
  packet.set(infoHashBytes, 20);
  
  // Bytes 40-59: Manifest Hash (20 bytes)
  const manifestHashBytes = hexToBytes(manifestHash, 20);
  packet.set(manifestHashBytes, 40);
  
  // Bytes 60-63: CRC32C Checksum (4 bytes)
  const checksumTarget = packet.subarray(0, 60);
  const checksum = calculateChecksum(checksumTarget);
  view.setUint32(60, checksum, true);
  
  return encodeBase64Url(packet);
}
